const baseFont = {
	fontFamily: "Inter",
	color: "#1F2937",
	fontSize: 15,
	lineHeight: "21px"
};

const headerFont = {
	...baseFont,
	fontWeight: "bold",
	color: "#111827",
	marginBottom: 10
};

const listIcon = {
	color: "#1F2937",
	marginLeft: 10,
	marginRight: 10,
	fontSize: 15
};

export const markdownStyles = {
	body: baseFont,
	paragraph: {
		...baseFont,
		marginBottom: 10
	},
	heading1: {
		...headerFont,
		fontSize: 24,
		marginTop: 10
	},
	heading2: {
		...headerFont,
		fontSize: 20,
		marginTop: 16
	},
	heading3: {
		...headerFont,
		fontSize: 18,
		marginTop: 14
	},
	heading4: {
		...headerFont,
		fontSize: 16,
		marginTop: 12
	},
	heading5: {
		...headerFont,
		fontSize: 14,
		marginTop: 10
	},
	heading6: {
		...headerFont,
		fontSize: 12,
		marginTop: 10
	},
	strong: {
		fontFamily: "Inter",
		fontWeight: "bold",
		color: "#111827"
	},
	em: {
		fontFamily: "Inter",
		fontStyle: "italic",
		color: "#1F2937"
	},
	link: {
		fontFamily: "Inter",
		color: "rgb(80, 76, 154)",
		textDecorationLine: "underline"
	},
	bullet_list: {
		marginBottom: 10
	},
	ordered_list: {
		marginBottom: 10
	},
	bullet_list_icon: listIcon,
	bullet_list_content: baseFont,
	ordered_list_icon: {
		...listIcon,
		fontFamily: "Inter"
	},
	ordered_list_content: baseFont,
	blockquote: {
		backgroundColor: "#F3F4F6",
		borderLeftWidth: 4,
		borderLeftColor: "#D1D5DB",
		paddingHorizontal: 10,
		paddingVertical: 10,
		marginBottom: 10
	},
	code_inline: {
		backgroundColor: "#F3F4F6",
		fontFamily: "Inter",
		borderRadius: 4,
		paddingHorizontal: 4,
		color: "#1F2937"
	},
	code_block: {
		backgroundColor: "#F3F4F6",
		borderRadius: 8,
		padding: 10,
		marginBottom: 10,
		fontFamily: "Inter",
		color: "#1F2937"
	},
	fence: {
		backgroundColor: "#F3F4F6",
		borderRadius: 8,
		padding: 10,
		marginBottom: 10,
		fontFamily: "Inter",
		color: "#1F2937"
	},
	table: {
		borderWidth: 1,
		borderColor: "#E5E7EB",
		borderRadius: 4,
		marginBottom: 10
	},
	tr: {
		borderBottomWidth: 1,
		borderBottomColor: "#E5E7EB",
		flexDirection: "row"
	},
	th: {
		flex: 1,
		padding: 10,
		backgroundColor: "#F9FAFB",
		fontWeight: "bold",
		fontFamily: "Inter",
		color: "#111827"
	},
	td: {
		flex: 1,
		padding: 10,
		fontFamily: "Inter",
		color: "#1F2937"
	},
	hr: {
		backgroundColor: "#E5E7EB",
		height: 1,
		marginVertical: 10
	},
	image: {
		width: "100%",
		aspectRatio: 16 / 9,
		borderRadius: 8,
		marginBottom: 10
	}
};

